<script>
	import { querystring, push } from 'svelte-spa-router';
	import { onMount } from 'svelte';


	onMount(() => {
		const params = new URLSearchParams($querystring);
		if (params.has("uid")) {
			const uid = params.get("uid");
			push(`/User_Review?uid=${uid}`);
		}
	});
</script>